var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "progress-icon",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.83 14.17A8.079 8.079 0 0 1 1 9.03C1 4.595 4.538 1 8.902 1c4.364 0 7.902 3.595 7.902 8.03M8.024 17a9.256 9.256 0 0 1-1.756-.393m6.146-.828c-.286.104-.579.202-.878.29m7.902-9.801l-2.402 4.39-3.744-2.816"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogressIcon);
export default __webpack_public_path__ + "static/media/inprogress-icon.c47a0151.svg";
export { ForwardRef as ReactComponent };